
// src/web/components/diary-comment.jsx

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import connect from '../../connects/diary-comment'
import { themr } from 'react-css-themr'
import diaryTheme from './themes/diary.css'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import {
  Card,
  CardText,
} from 'react-toolbox/lib/card'
import {
  Avatar
} from 'react-toolbox/lib/avatar'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import DiaryUser from './diary-user.jsx'
import DiaryTimestamp from './diary-timestamp.jsx'
import DiaryLikes from './diary-likes.jsx'
import DiaryContent from './diary-content.jsx'
import DiaryActions from './diary-actions.jsx'
import DiaryAttachments from './diary-attachments.jsx'
import DiaryMentionsTo from './diary-mentions-to.jsx'
import DiaryCommentForm from './diary-comment-form.jsx'
import ConfirmDialog from './confirm-dialog.jsx'
import CardTitleRightActionsComment from './card-title-right-actions-comment'
import { isCommentStamp } from '../../helpers/is-stamp'

@themr('Diary', diaryTheme)
class DiaryCommentChild extends PureComponent {
  state = {}
  onDeleteConfirm = ()=> this.setState({ deleteConfirm: true })
  onDeleteConfirmYes = ()=> { this.setState({ deleteConfirm: false }); this.props.deleteComment() }
  onDeleteConfirmNo = ()=> this.setState({ deleteConfirm: false })
	onCommentEdit = ()=> this.setState({ editComment: !this.state.editComment })

  render() {
    const {
      t,
      theme,
      comment,
			diary,
			parent,
      user,
      group,
      cont,
      searchHits,
      commentForm,
      disableLike,
      showUser,
      likeComment,
      unlikeComment,
      reactionComment,
      deleteComment,
      showAttachments,
      showReaders,
      showMentions,
      onReplyComment,
      onStamp,
      likeConfig,
      showImagesView,
      isShowTimeStamp,
    } = this.props

    const myself = comment.user.user_id == user.user_id
    const like = _.find(comment.likes, (like)=> like.user.user_id == user.user_id)
		const isStamp = isCommentStamp(comment.comment) // コメントの内容がスタンプの場合は編集させないようにする

    return (
			<div>
      {!this.state.editComment && <CardText className="diaryReply" theme={theme} >
        <Avatar theme={theme} className="avatar" image={comment.user.icon_image.thumb_url} onClick={showUser} />
        <Card theme={theme} className="comment">
          <CardTitleRightActionsComment
              className="comment"
              subtitle={[
              <DiaryUser key="user" user={comment.user} showUser={showUser} />,
              isShowTimeStamp ? <DiaryTimestamp key="timestamp" timestamp={comment.created_at} updated={comment.updated_at} />: null
              ]}
              rightActions={
								(isStamp && user.user_id == comment.user.user_id || user.user_id != comment.user.user_id && group && group.is_admin) &&
                <IconButton icon='close' style={{ width: 27, height: 27 }} onClick={this.onDeleteConfirm} /> ||
                (!isStamp && user.user_id == comment.user.user_id) &&
								<IconMenu icon='more_vert' position='topRight'>
          				<MenuItem caption={t('label:コメントを編集')} onClick={this.onCommentEdit} icon="mode_edit" />
          				<MenuItem caption={t('label:コメントを削除')} onClick={this.onDeleteConfirm} icon="delete_forever" />
                </IconMenu>
              } />
          <DiaryContent content={comment.comment} comment searchHits={searchHits}/>
          <DiaryAttachments comment comment_id={comment.comment_id} files={comment.files} showAttachments={showAttachments} showImagesView={showImagesView}/>
          <CardText theme={theme} className="interaction">
            <DiaryLikes myself={myself} key="likes" comment_id={comment.comment_id} likes={comment.likes} likes_count={comment.likes_count} myself={comment.user.user_id == user.user_id} showReaders={showReaders} likeConfig={likeConfig}/>
            <DiaryMentionsTo key="mentions" comment_id={comment.comment_id} mentions={comment.mentions} showReaders={showMentions} reply_requested={comment.reply_requested}/>
          </CardText>
          <DiaryActions
              like={like}
              disableLike={disableLike}
              onLike={like && unlikeComment || likeComment}
              onReaction={reactionComment}
              onComment={onReplyComment}
              onStamp={onStamp}
              isComment={true}
              parent={parent}
              likeConfig={likeConfig} />
          <ConfirmDialog open={this.state.deleteConfirm}
              title={t('label:コメントを削除してもいいですか')}
              description={t('label:この操作は取り消せません')}
              yesLabel={t('label:削除')}
              noLabel={t('label:取り消し')}
              onYes={this.onDeleteConfirmYes}
              onNo={this.onDeleteConfirmNo} />
        </Card>
      </CardText>}
			{this.state.editComment &&
				<DiaryCommentForm
						diary={diary}
						group={group}
						user={user}
						parent={comment}
						editComment={comment}
						onClose={this.onCommentEdit} />
			}
			</div>
    )
  }
}

export const RawDiaryCommentChild = DiaryCommentChild
export default connect(DiaryCommentChild)



// WEBPACK FOOTER //
// ./src/web/components/diary-comment-child.jsx